import Filter from '../src/Filter/index.tsx';
export default Filter;
